import React from "react";
import { Box, Typography } from "@mui/material";
import { useBlogHeroSectionStyles } from "./BlogHeroSection.styles";
import { useI18n } from "../../../../i8n/useI18n";

const BlogHeroSection = () => {
    const { classes } = useBlogHeroSectionStyles();
    const { t } = useI18n();

    return (
        <Box className={classes.root}>
            <Box className={classes.container}>
                <Typography variant="h1">{t("blogPage.hero.title")}</Typography>
                <Typography variant="body1" className={classes.description}>
                    {t("blogPage.hero.description")}
                </Typography>
            </Box>
        </Box>
    );
};

export default BlogHeroSection;
